<template>
  <div>
    <v-card
      v-if="!showMobileView"
      class="mr-4 mt-4 mb-1 d-flex align-center"
      height="40"
      width="148"
      color="secondary"
      style="
                  color: white;
                  font-weight: bold;
                "
      @click="downloadPDF()"
    >
      <v-row>
        <v-spacer />
        <v-spacer />
        <v-row class="d-flex justify-space-around" id="reports-export-button">
          <v-icon color="white">mdi-download</v-icon>
          Download PDF
        </v-row>
        <v-spacer />
        <v-spacer />
      </v-row>
    </v-card>
    <v-card
      v-else
      class="mr-4 mt-6 d-flex align-center flex-shrink-0"
      height="40"
      width="40"
      color="secondary"
      @click="_setFilter(true)"
    >
      <v-row>
        <v-spacer />
        <v-col>
          <v-icon color="white">mdi-download</v-icon>
        </v-col>
        <v-spacer />
      </v-row>
    </v-card>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :paginate-elements-by-height="1000"
      filename="Shark Cam Report"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      ref="html2Pdf"
    >
      <PDFContent
        slot="pdf-content"
        :_roundsPlayed="_roundsPlayed"
        :_dynamicYardageChart="_dynamicYardageChart"
        :_scorecardChart="_scorecardChart"
        :_foodAndBeverageChart="_foodAndBeverageChart"
        :_listenChart="_listenChart"
        :_watchChart="_watchChart"
      />
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import PDFContent from './PDFContent.vue';
import { MobileView } from '@/mixins';

export default {
  components: {
    PDFContent,
    VueHtml2pdf,
  },
  mixins: [MobileView],
  props: [
    '_dynamicYardageChart',
    '_roundsPlayed',
    '_scorecardChart',
    '_foodAndBeverageChart',
    '_listenChart',
    '_watchChart',
  ],
  methods: {
    downloadPDF() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>

<style></style>
